import { render } from "./ImportConfigurationVersionsModal.vue?vue&type=template&id=005dbbfc&scoped=true&ts=true"
import script from "./ImportConfigurationVersionsModal.vue?vue&type=script&lang=ts"
export * from "./ImportConfigurationVersionsModal.vue?vue&type=script&lang=ts"

import "./ImportConfigurationVersionsModal.vue?vue&type=style&index=0&id=005dbbfc&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005dbbfc"]])

export default __exports__